import { validDate } from "components/Travel/function";
export const updateObject = (oldObject: any, updatedProperties: any) => {
  return {
    ...oldObject,
    ...updatedProperties
  };
};

export const formatReplace = (type: string, value: any, os?: string) => {
  if (type === "relatorEngName") {
    value = value.replace(/^ /gi, "");
    if (os === "mobile") {
      return value.toUpperCase().replace(/[^A-Za-z-\s]/gi, "");
    } else {
      return value.toUpperCase();
    }
  } else {
    value = value.replace(/\s/gi, "");
    if (type === "relatorName") {
      if (value.length > 20) {
        value = value.substr(0, 20);
      }
      if (os === "mobile") {
        return value.replace(
          /[^가-힣ㄱ-ㅎㅏ-ㅣ\u318D\u119E\u11A2\u2022\u2025a\u00B7\uFE55]/gi,
          ""
        );
      } else {
        return value;
      }
    }
    if (
      type === "relatorBirthDate" ||
      type === "identificationFront" ||
      type === "identificationBack" ||
      type === "relatorMobileTelNo"
    ) {
      return value.replace(/[^0-9]/gi, "");
    }
    if (type === "relatorEmail") {
      if (os === "mobile") {
        return value.replace(/[(ㄱ-ㅎ|ㅏ-ㅣ|가-힣)]/gi, "");
      } else {
        return value;
      }
    }
  }
  return value;
};

export const checkValidity = (value: any, rules: any) => {
  let isValid = true;
  if (rules.required) {
    isValid = value.trim() !== "" && isValid;
  }
  if (rules.minLength) {
    isValid = value.length >= rules.minLength && isValid;
  }
  if (rules.maxLength) {
    isValid = value.length <= rules.maxLength && isValid;
  }
  if (rules.isEmail) {
    const pattern = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
    //const pattern = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    isValid = pattern.test(value.toLowerCase()) && isValid;
  }
  if (rules.isKorName) {
    const pattern = /^[가-힣]+$/g;
    isValid = pattern.test(value) && isValid;
  }
  if (rules.isEngName) {
    const pattern = /^[a-zA-Z-\s]+$/g;
    isValid = pattern.test(value) && isValid;
  }
  if (rules.isMobile) {
    const pattern = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
    isValid = pattern.test(value) && isValid;
  }
  if (rules.isnumeric) {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
  }
  if (rules.isBirth) {
    const isBefore = validDate("startDate", value);
    const pattern = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
    isValid = pattern.test(value) && isBefore && isValid;
  }
  return isValid;
};
